import { useTranslation } from 'react-i18next'

import { FormikForm } from '../../../Formik'
import Modal, { Box, Header } from '../../../Modal'

import { FormFields } from './FormFields'

function SelectPrinterModal(props) {
  const { initialValues, options } = props

  const { t } = useTranslation()

  return (
    <Modal onClose={props.onClose}>
      <Box size='m'>
        <Header
          text={t('Modal.PrinterTitleModalText')}
          onClose={props.onClose}
        />
        <FormikForm
          initialValues={initialValues}
          validationOnBlur={false}
          onSubmit={props.onSubmit}
        >
          <FormFields options={options} onCancel={props.onClose} />
        </FormikForm>
      </Box>
    </Modal>
  )
}

export default SelectPrinterModal
